import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
    width: fit-content;
    height: fit-content;

    .toggle_switch {
        position: relative;
        display: inline-block;
        width: 32px;
        height: 16px;
    }

    .toggle_switch .toggle_input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .toggle_slider {
        display: block;
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: ${({theme}) => theme['gray-600']};
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 10px;
    }

    .toggle_slider:before {
        position: absolute;
        content: '';
        height: 10px;
        width: 10px;
        left: 3.4px;
        bottom: 2.8px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 50%;
    }

    .toggle_input:checked + .toggle_slider {
        background-color: ${({ theme }) => theme['blue-500']};
    }

    .toggle_input:focus + .toggle_slider {
        box-shadow: 0 0 1px #2196f3;
    }

    .toggle_input:checked + .toggle_slider:before {
        -webkit-transform: translateX(14.8px);
        -ms-transform: translateX(14.8px);
        transform: translateX(14.8px);
    }

    .toggle_label {
        font-family: ${({ theme }) => theme['font-regular']};
        font-size: 13px;
        padding: 0 !important;
        margin-left: 10px !important;
    }
`
